/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { VirtualElement } from "../components/core";

export interface ClientRectObject {
	x: number;
	y: number;
	top: number;
	left: number;
	right: number;
	bottom: number;
	width: number;
	height: number;
}

export function getBoundingClientRect(element: Element | VirtualElement): ClientRectObject {
	const rect = element.getBoundingClientRect();

	return {
		width: rect.width,
		height: rect.height,
		top: rect.top,
		right: rect.right,
		bottom: rect.bottom,
		left: rect.left,
		x: rect.left,
		y: rect.top
	};
}
